(function () {
  "use strict";

  var VERSION = "1.0.5";
  var EXPECTED_LIVE_THEME_ID = "203036688729";
  var CHECK_INTERVAL_MS = 30000;
  var previousRuntime = window.TrundesCartRuntime;
  var installed = false;
  var checking = false;
  var controller = null;
  var intervalId = null;
  var generation = 0;

  if (
    previousRuntime &&
    typeof previousRuntime.destroy === "function"
  ) {
    previousRuntime.destroy();
  }

  function localBuild() {
    var meta = document.querySelector(
      'meta[name="tr-live-build"]'
    );

    return meta
      ? String(meta.getAttribute("content") || "")
      : "";
  }

  function cleanSuccessfulBuildParameter() {
    var url = new URL(window.location.href);
    var refreshedBuild = String(
      url.searchParams.get("__tr_build") || ""
    );

    if (!refreshedBuild || localBuild() !== refreshedBuild) {
      return;
    }

    url.searchParams.delete("__tr_build");

    window.history.replaceState(
      window.history.state,
      "",
      url.pathname + (url.search || "") + (url.hash || "")
    );
  }

  function parseBeacon(html) {
    var documentCopy = new DOMParser().parseFromString(
      html,
      "text/html"
    );
    var beacon = documentCopy.querySelector(
      "[data-tr-live-beacon]"
    );

    if (!beacon) {
      throw new Error("Live build beacon was not returned.");
    }

    return {
      themeId: String(
        beacon.getAttribute("data-theme-id") || ""
      ),
      role: String(
        beacon.getAttribute("data-theme-role") || ""
      ),
      build: String(
        beacon.getAttribute("data-build") || ""
      )
    };
  }

  async function fetchLiveBuild(signal) {
    var url = new URL("/", window.location.href);

    url.searchParams.set("section_id", "tr-live-beacon");
    url.searchParams.set("__tr_fresh", String(Date.now()));

    var response = await fetch(url.toString(), {
      method: "GET",
      credentials: "omit",
      cache: "no-store",
      redirect: "follow",
      signal: signal,
      headers: {
        Accept: "text/html",
        "Cache-Control": "no-cache",
        Pragma: "no-cache"
      }
    });

    if (!response.ok) {
      throw new Error(
        "Live build beacon request failed: " + response.status
      );
    }

    return parseBeacon(await response.text());
  }

  function refreshStorageKey(build) {
    return "trundes:build-refresh:" + build;
  }

  function refreshWasAttempted(build) {
    try {
      return window.sessionStorage.getItem(
        refreshStorageKey(build)
      ) === "1";
    } catch (error) {
      console.warn(
        "Build refresh was skipped because session storage is unavailable.",
        error
      );
      return true;
    }
  }

  function rememberRefreshAttempt(build) {
    try {
      window.sessionStorage.setItem(
        refreshStorageKey(build),
        "1"
      );
      return true;
    } catch (error) {
      console.warn(
        "Build refresh was skipped because session storage is unavailable.",
        error
      );
      return false;
    }
  }

  function refreshToBuild(build) {
    if (refreshWasAttempted(build)) {
      console.warn(
        "Build refresh was already attempted for " + build + "."
      );
      return;
    }

    if (!rememberRefreshAttempt(build)) {
      return;
    }

    var targetUrl = new URL(window.location.href);

    [
      "__tr_build",
      "__tr_fresh",
      "__tr_stale_cart",
      "__tr_live",
      "__tr_document"
    ].forEach(function (parameter) {
      targetUrl.searchParams.delete(parameter);
    });

    targetUrl.searchParams.set("__tr_build", build);
    window.location.replace(targetUrl.toString());
  }

  async function checkBuild() {
    if (!installed || checking || !controller) {
      return;
    }

    checking = true;
    var currentGeneration = generation;

    try {
      var beacon = await fetchLiveBuild(controller.signal);

      if (
        !installed ||
        currentGeneration !== generation ||
        beacon.themeId !== EXPECTED_LIVE_THEME_ID ||
        beacon.role.toLowerCase() !== "main" ||
        !beacon.build
      ) {
        return;
      }

      if (localBuild() !== beacon.build) {
        refreshToBuild(beacon.build);
      }
    } catch (error) {
      if (!error || error.name !== "AbortError") {
        console.warn("Live build check failed.", error);
      }
    } finally {
      if (currentGeneration === generation) {
        checking = false;
      }
    }
  }

  function handlePageShow() {
    checkBuild();
  }

  function handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      checkBuild();
    }
  }

  function destroy() {
    generation += 1;
    installed = false;
    checking = false;

    if (controller) {
      controller.abort();
      controller = null;
    }

    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function install() {
    if (installed) {
      return;
    }

    installed = true;
    generation += 1;
    controller = new AbortController();

    cleanSuccessfulBuildParameter();

    window.addEventListener("pageshow", handlePageShow, {
      signal: controller.signal
    });
    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange,
      { signal: controller.signal }
    );

    intervalId = window.setInterval(
      checkBuild,
      CHECK_INTERVAL_MS
    );

    checkBuild();
  }

  window.TrundesCartRuntime = {
    version: VERSION,
    install: install,
    destroy: destroy,
    isBusy: function () {
      return false;
    },
    configure: function () {}
  };

  install();
})();
